var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c(
        "app-section",
        [_c("app-title", [_vm._v(_vm._s(_vm.$ct("title")))])],
        1
      ),
      !_vm.finished
        ? [
            !_vm.finished
              ? _c(
                  "app-section",
                  [
                    _c("w-input", {
                      attrs: {
                        label: _vm.$ct("email"),
                        required: "",
                        fancy: "",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "app-section",
              [
                _c(
                  "app-button",
                  {
                    staticClass: "mt",
                    attrs: { disabled: _vm.buttonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.resetPassword()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("action")) + " ")]
                ),
                _c(
                  "app-text",
                  { staticClass: "mt" },
                  [
                    _c("w-link", { attrs: { to: "/" } }, [
                      _vm._v(" " + _vm._s(_vm.$ct("back")) + " "),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _c(
            "app-section",
            [
              _c("app-text", [
                _vm._v(" " + _vm._s(_vm.$ct("email-sent")) + " "),
              ]),
              _c(
                "app-text",
                { staticClass: "mt" },
                [
                  _c("w-link", { attrs: { to: "/" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("back")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }